module.exports = __webpack_public_path__ + "static/pp2-ca2fadd6011b4e4d39f6c6fbe1ed326f.jpg";